// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.logout-question[data-v-06f0236e] {\n    font-size: 1.2em;\n    color: #444444;\n    text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
